import Toastify from 'toastify-js';
const show = (toast) => {
    Toastify(toast).showToast();
};
const success = (text) => {
    show({
        text,
        className: "success",
        style: {
            background: "linear-gradient(to right, #00b09b, #96c93d)",
        }
    });
};
const warn = (text) => {
    show({
        text,
        className: "warning",
        newWindow: false,
        oldestFirst: false,
        style: {
            background: "linear-gradient(to right, #b08600, #c99a3d)",
        },
    });
};
const get = (object, key, defaultValue) => {
    if (object === null) {
        return defaultValue;
    }
    if (key.indexOf('.') === -1) {
        return object[key] !== undefined ? object[key] : defaultValue;
    }
    const keys = key.split('.'); // we support nested keys
    let result = object; // we start at the first level
    for (let i = 0; i < keys.length; i++) {
        // iterate through the keys
        result = result[keys[i]]; // we look for the next level
        if (result === undefined) {
            // if it's undefined, we return the default value
            return defaultValue;
        }
    }
    return result;
};
const error = (err) => {
    show({
        className: 'error',
        // title: get(err, 'code', 'Error'),
        text: get(err, 'message', "Ops, Looks like something went wrong!"),
        duration: 5 * 1000,
        close: true,
        gravity: "bottom",
        style: {
            background: "linear-gradient(to right, #b00049, #3d66c9)",
        },
        onClick: () => { }
    });
};
export default { show, error, warn, success };
